import {makeAutoObservable} from "mobx";
import {WeighingListItemDto} from "../../api/kpi";
import {api, catchApi} from "../../api";

class KpiWeighingDialogListStore {
    get customerId(): string | undefined {
        return this._customerId;
    }

    set customerId(value: string | undefined) {
        this._customerId = value;
    }
    get items(): WeighingListItemDto[] {
        return this._items;
    }

    set items(value: WeighingListItemDto[]) {
        this._items = value;
    }

    private _customerId: string | undefined
    private _items: WeighingListItemDto[] = []

    constructor() {
        makeAutoObservable(this)
    }

    async load() {
        const {customerId} = this
        const response = await catchApi(async () => api.kpi.api.listWeighings({
            customerId
        }))
        const responseData = response?.data

        this.items = responseData?.items || []
    }

    setCustomerId(id: string | undefined) {
        const updatedNeeded = this.customerId !== id
        this.customerId = id
        if (updatedNeeded) {
            this.load().finally()
        }
    }
}


const kpiWeighingDialogListStore = new KpiWeighingDialogListStore()

export {
    kpiWeighingDialogListStore
}
